export default __webpack_public_path__ + "static/media/03 Track 3.706850ac.mp3";